exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".clinic-availability{margin-top:54px}.clinic-availability .vuecal__event.available{background:var(--theme-color-arrived);color:#fff;cursor:pointer}.clinic-availability .vuecal__event.not-available{background:var(--theme-color-absent);color:#fff;cursor:pointer}.clinic-availability .vuecal__event.vacation{background:var(--theme-color);color:#fff;cursor:not-allowed}.clinic-availability .vuecal__now-line{display:none}", ""]);

// exports
